var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3063d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2.138)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(-5 -2.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.484,3.125H1.832A1.832,1.832,0,0,0,0,4.957v16.49A1.834,1.834,0,0,0,1.832,23.28H27.484a1.834,1.834,0,0,0,1.832-1.832V4.957a1.834,1.834,0,0,0-1.832-1.832Zm0,18.323H1.832V4.957H27.484Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.788,24.786H37.123a.916.916,0,0,1-.916-.916H34.375a2.749,2.749,0,0,0,2.748,2.748h.916v1.832h1.832V26.619h.916a2.748,2.748,0,0,0,0-5.5H37.123a.916.916,0,0,1,0-1.832h3.665a.915.915,0,0,1,.916.916h1.832a2.749,2.749,0,0,0-2.748-2.748h-.916V15.625H38.04v1.832h-.916a2.748,2.748,0,1,0,0,5.5h3.665a.916.916,0,1,1,0,1.832Z",
    transform: "translate(-24.297 -8.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.916,78.125H0a1.834,1.834,0,0,0,1.832,1.832H27.484a1.834,1.834,0,0,0,1.832-1.832Z",
    transform: "translate(0 -52.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.916,90.625H0a1.834,1.834,0,0,0,1.832,1.832H27.484a1.834,1.834,0,0,0,1.832-1.832Z",
    transform: "translate(0 -59.974)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.f0e9a7894fae137e651af37d5d37eec3.svg";
export { ForwardRef as ReactComponent };